import { render, staticRenderFns } from "./RsaSchedaOspisteDimissioneTrasferimentoStoricoComponent.vue?vue&type=template&id=cebf7634"
import script from "./RsaSchedaOspisteDimissioneTrasferimentoStoricoComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaOspisteDimissioneTrasferimentoStoricoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports